import React, { useState } from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import DummyAvatar from "../../assets/images/Profile-thumbnail-small.svg";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

export default function StudentsAssignment({ assignmentList }) {
  
  // State for pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(4);
  const [searchParams] = useSearchParams();

  // Ensure valid course array
  const courseList = Array.isArray(assignmentList) ? assignmentList : [];

  // Pagination logic
  const totalPages = Math.max(1, Math.ceil(courseList.length / rowsPerPage));
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const currentCourses = courseList.slice(startIndex, endIndex);

  // Handle page change
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  // Handle rows per page change
  const handleRowsChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setCurrentPage(1); // Reset to first page when rows per page changes
  };

  return (
    <>
      <div className="d-flex align-item-center justify-content-end d-sm-none">
        <label className="me-2 flex-shrink-0 align-self-center">
          No of Rows
        </label>
        <select
          className="form-control ms-16"
          value={rowsPerPage}
          onChange={handleRowsChange}
          style={{ width: "100px" }}
        >
          <option value={4}>4</option>
          <option value={6}>6</option>
          <option value={8}>8</option>
          <option value={10}>10</option>
        </select>
      </div>
      <div className="table-responsive mb-10">
        <table className="table instructor-course-table custom-table student-table align-middle">
          <thead>
            <tr>
              <th className="ah-text-base">Sr No.</th>
              <th className="ah-text-base">Student Name</th>
              <th className="ah-text-base text-center">Marks</th>
              <th className="ah-text-base text-center">Type</th>
              <th className="ah-text-base text-center">Status</th>
              <th className="ah-text-base text-center">Assignment</th>
            </tr>
          </thead>
          <tbody>
            {currentCourses.map((course, index) => (
              <tr key={course.id}>
                <td>
                  <div className="counter-block">{startIndex + index + 1}</div>
                </td>
                <td>
                  <div className="d-flex align-items-center">
                    <div className="img-holder me-15">
                      <Image
                        src={
                          process.env.REACT_APP_GALLERY_URL +
                          course?.profile_picture
                        }
                        alt={`Thumbnail ${index + 1}`}
                        className="img-fluid"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = DummyAvatar;
                        }}
                      />
                    </div>
                    <strong className="ah-text-sm fw-semibold">
                      {course?.full_name}
                    </strong>
                  </div>
                </td>
                <td className="text-center">
                  <CircularProgressbar
                    className="progress-circle-holder"
                    value={Number(course?.marksPercentage)}
                    strokeWidth={16}
                    text={course?.marksPercentage}
                    styles={{
                      path: {
                        stroke: course?.marks ? course.fill : "",
                      },
                      text: {
                        fill: "#000",
                        fontSize: "22px",
                      },
                      trail: {
                        stroke: course.stroke,
                      },
                    }}
                  />
                </td>
                <td className="ah-text-sm text-center fw-semibold">
                  {course?.assignment_type === "multiple_choice"
                    ? "Multiple Choice"
                    : course?.assignment_type === "short_answer"
                    ? "Short Answer"
                    : course?.assignment_type === "comprehensive"
                    ? "Comprehensive"
                    : ""}
                </td>
                <td>
                  <div className="text-center fw-semibold">
                    {course?.isMarkedByInstructor ? "Marked" : "Unmarked"}
                  </div>
                </td>
                <td className="ah-text-sm text-center fw-semibold">
                  {/* {course?.assignment_type === "multiple_choice" ? (
                    <button
                      type="button"
                      disabled={true}
                      className="btn btn-primary fw-semibold no-shadow py-7 ah-text-sm"
                    >
                      View assignment
                    </button>
                  ) : ( */}
                    <Link
                      className="btn btn-primary fw-semibold no-shadow py-7 ah-text-sm"
                      to={`/assignment-marking?assignment_id=${searchParams.get(
                        "id"
                      )}&student_id=${course?.id}&course_id=${searchParams.get(
                        "course_id"
                      )}`}
                    >
                      View assignment
                    </Link>
                  {/* // )} */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div className="d-flex justify-content-center  justify-content-sm-between align-items-center custom-pagination-holder">
        <div className="">
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <svg
              style={{ transform: "rotate(-90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Prev
          </button>
          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i + 1}
              className={`bg-transparent border-0 ${
                currentPage === i + 1
                  ? "pagination-item active"
                  : "pagination-item"
              } me-2`}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            className="me-2 border-0 bg-transparent p-0"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
            <svg
              style={{ transform: "rotate(90deg)" }}
              width="12"
              height="10"
              viewBox="0 0 17 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7646 8.65686L8.76465 1.65686L1.76465 8.65686"
                stroke="#000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>

        {/* Rows per page selector */}
        <div className="align-item-center d-none d-sm-flex">
          <label className="me-2 flex-shrink-0 align-self-center">
            No of Rows
          </label>
          <select
            className="form-control ms-16"
            value={rowsPerPage}
            onChange={handleRowsChange}
            style={{ width: "100px" }}
          >
            <option value={4}>4</option>
            <option value={6}>6</option>
            <option value={8}>8</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>
    </>
  );
}
